import {MuBinder} from "mu-widget/lib/MuBinder";
import {formatDate} from "./Utils";

export function setupFilters() {
	MuBinder.filters.percent = (value : number) => value.toString() + "%";
	MuBinder.filters.percentD = (value : number) => (value * 100).toString() + "%";
	MuBinder.filters.number2d = (value : number) => (Math.round(value * 100) / 100).toFixed(2).toLocaleString();
	MuBinder.filters.date = function(value : Date|string, ev, format : string = "date") {
		if (typeof value === "string") value = new Date(value);
		//todo: format

		const optss = {
			date: {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit'
			},
			datetime: {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
			}
		}
		return value.toLocaleDateString('cz-CZ', optss[format]);
	};
	MuBinder.filters.dateTime = (value, ev, format: string) => formatDate(format, value);
	MuBinder.filters.snumber = (value : string) => {
		let f = true;
		let res = "";
		value = "   " + value.toString().padStart(3, '0');
		res = ',' + value.substr(-2);

		for(let p = value.length - 5; p >= 0; p -= 3) {
			res = ' ' + value.substr(p, 3) + res;
		}
		return res;
	}
	MuBinder.filters.priceI100 = (value: string) => parseInt(value) / 100;
	MuBinder.filters.priceI100r = (value: string) => Math.round(parseFloat(value) * 100);
	MuBinder.filters.priceV = (value: number) => MuBinder.filters.snumber(Math.round(value * 100));
}